<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
    <mat-drawer-container 
        class="flex-auto h-full bg-card dark:bg-transparent"
        (backdropClick)="onBackdropClicked()">

        <!-- File Details Drawer -->
        <!--//drawerMode-->
        <mat-drawer 
        class="item-details-drawer w-full sm:w-100 md:w-100 dark:bg-gray-900"
        [mode]="drawerMode" 
        [opened]="false"
        [position]="'end'"
        [disableClose]="false"
        #matDrawer>
        <router-outlet *ngIf="!util.getIsWebApp()"></router-outlet>
        <recents-details *ngIf="util.getIsWebApp()" [docId]="assetId" [selectedTab]="activeTab"></recents-details>
    </mat-drawer>

        <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">

            <!-- Main -->
            <div class="flex flex-col flex-auto">

                <div class="my-2">
                    <desktop-agent-banner></desktop-agent-banner>
                </div>

                <!-- Header -->
                <div class="flex flex-row items-center justify-start p-3 sm:py-6 md:px-6 border-b bg-card dark:bg-transparent file-manager-explorer-header">
                    <!-- Sidebar toggle button -->
                    <button 
                        *ngIf="!defaultView" 
                        mat-icon-button (click)="_fileManagerComponent.fileManagerDrawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                    <!-- Title -->
                    <div class="flex flex-col ml-3">
                        <div class="text-2xl font-extrabold tracking-tight leading-none">Recent</div>
                    </div>
                    
                    <!-- Actions -->
                    <div class="ml-auto">
                         <!-- Sidebar toggle button -->
                         <button mat-button 
                            class="header-action-button-minimal"
                            [color]="'primary'" 
                            [matTooltip]="filterPanel.expanded ? 'Hide filters' : 'Show filters'"
                            (click)="toggleFilterPanel()"
                            [ngClass]="{'button-active-dv': filterPanel.expanded}">
                            <mat-icon [svgIcon]="'mat_outline:filter_list'"></mat-icon>
                        </button>
                        <!-- Toggle View Mode -->
                        <button mat-button 
                            class="header-action-button-minimal"
                            [color]="'primary'" 
                            [matTooltip]="viewMode === 'cards' ? 'View List' : 'View Cards'"
                            (click)="toggleViewMode()">
                            <mat-icon [svgIcon]="viewMode === 'cards' ? 'mat_outline:view_list' : 'mat_outline:grid_view'"></mat-icon>
                        </button>
                    </div>
                </div>
                <!--Header Controls - START -->
                <div class="col file-manager-filter-panel text-md font-semibold 
                    text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 fade-transition">
                    
                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel #filterPanel="matExpansionPanel" hideToggle
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'16px'">
                            
                        </mat-expansion-panel-header>
                        <!--Panel of Search Options-->
                        <app-filter [labels]="labels" [FilterFields]="assetsFilterFields"   (onFilterChanges)="onFilterChange($event)"></app-filter>
                        
                    </mat-expansion-panel>
                   
                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel #multiItemSelectPanel="matExpansionPanel"
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5 file-manager-multi-item-actions file-grid z-10 sticky top-0 grid">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'0px'">
                            
                        </mat-expansion-panel-header>
                        <!--Panel of Control Options for multiple files-->
                        <div class="row flex">
                            <div class="row flex justify-start items-center mr-2">
                                <button mat-icon-button 
                                    matTooltip="Cancel bulk action"
                                    (click)="cancelBulkAction()">
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                                </button>
                            </div>
                            <div class="flex row items-center mr-6">
                                <span class="mr-2">{{selectedRows.length}}</span>
                                <span>selected</span>
                            </div>
                            <div class="row flex justify-start items-center justify-center">
                                <span [matTooltip]="isFolderRowSelected() ? 'Cannot bulk download folders' : 'Download'" matTooltipPosition="above">
                                    <button mat-icon-button [disabled]="isFolderRowSelected()" (click)="download_multi()">
                                        <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                    </button>
                                </span>
                                <button mat-icon-button matTooltip="Move"
                                [appAction]="{ action: 'move', item: selectedRows }"
                                (click)="move_multi()"
                                    >
                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                </button>
                                <!-- Toggle starred button -->
                                <button mat-icon-button matTooltip="Favorite" 
                                    (click)="toggleStar_multi()">
                                    <mat-icon
                                        class="icon-size-4"
                                        [svgIcon]="'feather:star'"></mat-icon>
                                </button>
                                <button mat-icon-button [matTooltip]="'Trash' | lpmLabel:'deleteLabelText'"
                                    [appAction]="{ action: 'delete', item: selectedRows }"
                                    (click)="trash_multi()">
                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                </button>              
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!--Show/Hide panel of stats -->
                    <!---->
                    <mat-expansion-panel 
                        #statsPanel="matExpansionPanel"
                        (opened)="isStatsPanelOpen = true" (closed)="isStatsPanelOpen = false"
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'16px'">
                            
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="isStatsPanelOpen">
                            <!--<dv-bar-recent></dv-bar-recent>-->
                        </ng-container>
                    </mat-expansion-panel>
                </div>
                <!-- Header Controls - END -->


                <!-- Items list -->
                <ng-container *ngIf="assets && (assets?.length > 0); else noItems">

                    <!-- Cards view -->
                    <ng-container *ngIf="viewMode === 'cards'">
                        <div class="p-6 md:p-8 space-y-8 fade-transition">
                              <!-- Files -->
                              <ng-container *ngIf="!isLoading && assets && assets.length > 0">
                                <div>
                                    <div class="font-medium">Files</div>
                                    <div
                                        class=" flex flex-row justify-start flex-wrap pb-2  gap-4 -m-2 mt-2">
                                        <ng-container *ngFor="let file of assets; trackBy:trackByFn">
                                            <div [dndDraggable]="file" (dragstart)="onDragStart($event, file)"
                                             (click)="drawerViewClick(file.id)"
                                             (dblclick)="drawerViewDblClick(file)"
                                                class=" item_card  pb-3  flex flex-col w-64 h-64   rounded-lg overflow-hidden shadow-md bg-white cursor-pointer">
                                                <!-- Header with filename and menu icon -->
                                                <div class="flex items-center gap-1 p-2 bg-gray-200">
                                                    <div class="flex items-center">
                                                        <div class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                                            <mat-icon *ngIf="file.locked" class="icon-size-4 absolute -left-3 text-orange-500 -top-1"
                                                                svgIcon="mat_outline:lock"></mat-icon>
                                                            <mat-icon class="file-icon-size" [svgIcon]="util.getFileTypeImage(file.extension)"></mat-icon>
                                                        </div>
                                                    </div>
                                                    <div class="truncate" [matTooltip]="file.name">{{file.name}}</div>
                                                    <button class="p-1 ms-auto rounded-full text-gray-500 hover:text-gray-700 hover:bg-gray-300"
                                                        matTooltip="Actions" [matMenuTriggerFor]="fmItemActionMenu_card" mat-icon-button>
                                                        <mat-menu #fmItemActionMenu_card="matMenu" class="file-manager-item-action-menu">
                                                            <button mat-menu-item [appAction]="{ action: 'download', item: file }" (click)="download(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                                <span>Download</span>
                                                            </button>
                                                            <button mat-menu-item [appAction]="{ action: 'share', item: file }"
                                                                (click)="_fileManagerComponent.shared(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                                <span>Share</span>
                                                            </button>
                                                            <button mat-menu-item [appAction]="{ action: 'copy', item: file }" (click)="copyAsset(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:file_copy"></mat-icon>
                                                                <span>Make a copy</span>
                                                            </button>
                                                            <div *ngIf="file.type=='FILE'" class="border-t"></div>
                                                            <div class="flex w-full">
                                                                <button *appAction="{ action: 'view', item: file }" mat-menu-item (click)="previewFile(file)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
                                                                    <span>View</span>
                                                                </button>
                                                                <button *appAction="{ action: 'edit', item: file }" mat-menu-item
                                                                    (click)="editFile(file)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:edit"></mat-icon>
                                                                    <span>Edit</span>
                                                                </button>
                                                            </div>
                                            
                                                            <div class="border-t"></div>
                                                            <button *appAction="{ action: 'lock', item: file }" mat-menu-item (click)="checkoutAsset(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:lock"></mat-icon>
                                                                <span>Lock</span>
                                                            </button>
                                                            <button *appAction="{ action: 'requestAccess', item: file }" mat-menu-item (click)="requestRelease(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:near_me"></mat-icon>
                                                                <span>Request lock release</span>
                                                            </button>
                                                            <button *appAction="{ action: 'unlock', item: file }" mat-menu-item (click)="checkInAsset(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:key"></mat-icon>
                                                                <span>Unlock</span>
                                                            </button>
                                                            <button mat-menu-item [appAction]="{ action: 'rename', item: file }"
                                                            (click)="_fileManagerComponent.renameItemDialog(file)">
                                                            <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                            <span>Rename</span>
                                                        </button>
                                                            <button mat-menu-item  (click)="drawerView(file.id)"
                                                                [matMenuTriggerFor]="fmItemActionMenu_card_sub2">
                                                                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                                                                <span>Details</span>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu_card_sub2="matMenu" class="file-manager-item-action-menu-sub">
                                                                <button mat-menu-item  (click)="drawerView(file.id, '0')">
                                                                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                                                                    <span>Info</span>
                                                                </button>
                                                                <button mat-menu-item  (click)="drawerView(file.id, '1')">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:auto_graph"></mat-icon>
                                                                    <span>Activity</span>
                                                                </button>
                                                                <button mat-menu-item  (click)="drawerView(file.id, '2')">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:notes"></mat-icon>
                                                                    <span>Notes</span>
                                                                </button>
                                                                <button mat-menu-item  (click)="drawerView(file.id, '3')" *appIsDisplayed="'viewPermissions'">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:admin_panel_settings"></mat-icon>
                                                                    <span>Permissions</span>
                                                                </button>
                                                            </mat-menu>
                                                            <button mat-menu-item [matMenuTriggerFor]="fmItemActionMenu_card_sub1">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                                <span>Organize</span>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu_card_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                                <button mat-menu-item [appAction]="{ action: 'move', item: file }" (click)="move(file)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                                    <span>Move</span>
                                                                </button>
                                                                <button mat-menu-item (click)="toggleStar(file)">
                                                                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:star"></mat-icon>
                                                                    <span>Star</span>
                                                                </button>
                                                                <button mat-menu-item [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                                    <span>Labels</span>
                                                                </button>
                                                                <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                                        <button mat-menu-item (click)="toggleLabel(file.id, label.id, checkbox)" matRipple>
                                                                            <mat-checkbox class="pointer-events-none label-chip" #checkbox
                                                                                [ngClass]="labelColors[label.color]?.combined" [color]="'primary'"
                                                                                [checked]="selectedLabel(label.id, file.labels)" [disableRipple]="true">
                                                                                {{label?.name}}
                                                                            </mat-checkbox>
                                                                        </button>
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </mat-menu>
                                                            <div class="border-t"></div>
                                                            <button *appAction="{ action: 'delete', item: file }"
                                                                    mat-menu-item (click)="trash(file)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                                <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                            </button>
                                                        </mat-menu>
                                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 12h.01M12 12h.01M18 12h.01">
                                                            </path>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <!-- Image Section -->
                                                <div *ngIf="file.thumbnail" class="p-4 flex-grow-2 flex justify-center items-center">
                                                    <img [src]="file.thumbnail" [href]="file.thumbnail" alt="Thumbnail Image" class="object-contain rounded-lg w-32 h-32">
                                                </div>
                                                <div class="w-32 h-32 flex justify-center my-auto items-center flex-grow-2 mx-auto " *ngIf="!file.thumbnail">
                                                    <div class="relative">
                                            
                                                        <mat-icon class="icon-size-14 text-hint opacity-50" [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                                        <div class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white no-select"
                                                            [ngClass]="getTypeColor(file.extension)">
                                                            {{file.extension.toUpperCase()}}
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                            
                                                <div *ngIf="file.locked||file.favourite" class="flex mt-auto flex-grow-1 card-footer-icons pb-3 ps-3">
                                                    <ng-container *ngIf="file.locked">
                                                        <mat-icon class="icon-size-4 text-orange-500" svgIcon="mat_outline:lock"></mat-icon>
                                                    </ng-container>
                                                    <ng-container *ngIf="file.favourite">
                                                        <mat-icon class="flex justify-center icon-size-4 ml-1 text-orange-500 dark:text-orange-400"
                                                            [svgIcon]="'heroicons_outline:star'">
                                                        </mat-icon>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <!-- Cards view - END -->

                    <!-- Grid List view -->
                    <!--Folders and Files are handled separately so that Folders always appears above Files-->
                    <ng-container *ngIf="viewMode === 'grid'" class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                        <div class="fade-transition">
                            <ng-container *ngIf="assets?.length > 0 ">
                                <div class="grid">
                                    <!-- Header -->
                                    <div
                                        class="file-grid z-10 items-center sticky top-0 grid gap-4 py-4 grid-header__record-row shadow text-md font-semibold 
                                            text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5"
                                        matSort matSort (matSortChange)="sortData($event)">
                                        <div class="col-1 absolute" >
                                            <mat-checkbox [color]="'primary'" class="mt-2" [checked]="isAllRowsSelected" (change)="toggleCheckAll()">
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-1"></div>
                                        <div class="col-2" >Name</div>
                                        <div
                                            class="col-3 hidden sm:hidden md:block lg:block"
                                            >
                                            Created
                                        </div>
                                        <div
                                            class="col-4 hidden sm:hidden md:hidden lg:block whitespace-nowrap"
                                            >
                                            Created By
                                        </div>
                                        <div
                                            class="col-5 hidden sm:hidden md:hidden lg:block"
                                            >
                                            Last Edit
                                        </div>
                                        <div
                                            class="col-6 hidden sm:hidden md:block lg:block"
                                            >
                                            File Size
                                        </div>
                                    </div>
                                    <!-- Rows -->
                                    <!--TODO - determine if async/lazy loading pagination is needed
                                        *ngIf="(products$ | async) as products"-->
                                    <fuse-loading-bar *ngIf="isLoading"></fuse-loading-bar>
                                    <ng-container *ngIf="!isLoading"> 
                                        <cdk-virtual-scroll-viewport 
                                            #viewport 
                                            [itemSize]="assets?.length" 
                                            class="file-manager-viewport"
                                            [ngClass]="{
                                                'file-grid-adj-filter-open': filterPanel.expanded && !statsPanel.expanded && !multiItemSelectPanel.expanded,
                                                'file-grid-adj-stats-open': statsPanel.expanded && !filterPanel.expanded && !multiItemSelectPanel.expanded,
                                                'file-grid-adj-multi-open': multiItemSelectPanel.expanded && !statsPanel.expanded && !filterPanel.expanded,
                                                'file-grid-adj-both-open': statsPanel.expanded && filterPanel.expanded
                                                }">
                                            <div *ngFor="let asset of assets; let i = index; trackBy:trackByFn" class="list-item-row">
                                                   
                                               <!-- Record Rows - Files -->
                                               <ng-container *ngIf="asset.type === 'FILE'" class="list-item-row">
                                                <div
                                                    matRipple
                                                    [matRippleRadius]="radius"
                                                    [matRippleColor]="color"
                                                    mat-table (click)="stopPropagation($event); drawerViewClick(asset.id)"
                                                    (dblclick)="drawerViewDblClick(asset)"
                                                    [class.selected]="isSelected(asset)"
                                                    (contextmenu)="onRightClick($event, asset)"
                                                    class="file-grid grid items-center gap-4 py-3 grid-header__record-row border-b cursor-pointer">
                                                    
                                                    <div class="flex items-center absolute">
                                                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelectedRow(asset)" (change)="toggleRowCheck($event.checked,asset)" class="" #checkbox [color]="'primary'" [disableRipple]="true">
                                                        </mat-checkbox>
                                                    </div>

                                                    <div class="flex items-center">
                                                        <div class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                                            <mat-icon *ngIf="asset.locked" class="icon-size-4 absolute -left-3 text-orange-500 -top-1" svgIcon="mat_outline:lock"></mat-icon>
                                                            <mat-icon class="file-icon-size"
                                                            [svgIcon]="util.getFileTypeImage(asset.extension)"></mat-icon>
                                                        </div>
                                                    </div>
    
                                                    <div class="flex items-center truncate no-select cursor-pointer file-manager-item-name-row">
                                                        <div matTooltip="{{asset.name}}"  
                                                            class="file-manager-item-name">
                                                            {{asset.name}}
                                                        </div>
                                                         <!-- Shared -->
                                                         <mat-icon
                                                         matTooltip="Shared"
                                                         matTooltipPosition="above"
                                                         *ngIf="asset.accessCount>1"
                                                         class="flex justify-center icon-size-4 ml-1 "
                                                         [svgIcon]="'heroicons_solid:users'">
                                                     </mat-icon>
                                                        <mat-icon
                                                            class="flex justify-center icon-size-4 ml-1 text-orange-500 dark:text-orange-400 fade-pulse"
                                                            *ngIf="asset?.favourite"
                                                            [svgIcon]="'heroicons_solid:star'">
                                                        </mat-icon>
                                                        <ng-container *ngIf="asset?.labels && asset.labels.length > 0">
                                                            <div class="flex flex-wrap items-center justify-start -mx-1 ml-1">
                                                                <ng-container *ngFor="let label of asset.labels">
                                                                    <div
                                                                        class="asset-label m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap no-select"
                                                                        [ngClass]="labelColors[label.color]?.combined">
                                                                        {{label.name}}
                                                                    </div>
                                                                </ng-container>
                                                            </div>
                                                        </ng-container>
                                                
                                                    </div>
    
                                                    <!-- Created -->
                                                    <div class="hidden col-3 hidden sm:hidden md:block lg:block no-select">
                                                        {{asset.createdDate | date : 'MM/dd/yyyy'}}
                                                    </div>
                                                    <!-- Uploaded By -->
                                                    <div class="hidden text-center col-3 hidden sm:hidden md:hidden lg:block no-select"
                                                    [innerHTML]="asset['innerDiv']" [matTooltip]="asset.createdBy | fullName">
                                                         {{asset?.createdBy | fullName}}
                                                    </div>
                                                    
                                                    <!-- Modified -->
                                                    <div class="hidden sm:hidden md:hidden lg:block no-select">
                                                        {{asset.updatedDate | date : 'MM/dd/yyyy'}}
                                                    </div>
    
                                                    <!-- File Size -->
                                                    <div class="hidden sm:hidden md:block lg:block no-select">
                                                        {{asset.size| fileSize}}
                                                    </div>
                                                    <!-- Last Edit Indicator -->
                                        
                                                    <div class="row flex justify-end">
                                                        <div class="row flex justify-end list-item-inline-actions">
                                                            <button mat-icon-button matTooltip="Download"
                                                                (click)="stopPropagation($event); download(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                            </button>
                                                            <button mat-icon-button matTooltip="Rename" *appCanViewAction="{ action: 'rename', item: asset }"
                                                                (click)="stopPropagation($event); _fileManagerComponent.renameItemDialog(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:edit-3"></mat-icon>
                                                            </button>
                                                            <button mat-icon-button matTooltip="Favorite" 
                                                                (click)="stopPropagation($event); toggleStar(asset)">
                                                                <mat-icon
                                                                    class="icon-size-4"
                                                                    [ngClass]="{'text-orange-500 dark:text-orange-400': asset?.favourite}"
                                                                    [svgIcon]="'feather:star'"></mat-icon>
                                                            </button>
                                                            <button mat-icon-button 
                                                                matTooltip="Details" 
                                                                (click)="stopPropagation($event)"
                                                                (click)="drawerView(asset.id)">
                                                                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                                                            </button>              
                                                        </div>
                                                        <button mat-icon-button matTooltip="Menu"
                                                                class="list-item-inline-action-menu"
                                                                (click)="stopPropagation($event)"
                                                                [matMenuTriggerFor]="fmItemActionMenu">
                                                                <mat-icon
                                                                    class="icon-size-4"
                                                                    [svgIcon]="'heroicons_solid:ellipsis-vertical'">
                                                                </mat-icon>
                                                        </button>
                                                        <mat-menu #fmItemActionMenu="matMenu" class="file-manager-item-action-menu">
                                                            <button mat-menu-item
                                                                [appAction]="{ action: 'download', item: asset }"
                                                                (click)="stopPropagation($event); download(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                                <span>Download</span>
                                                            </button>
                                                            <button mat-menu-item
                                                            [appAction]="{ action: 'share', item: asset }"
                                                            (click)="_fileManagerComponent.shared(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                                <span>Share</span>
                                                            </button>
                                                            <div class="border-t"></div>
                                                            <button mat-menu-item [appAction]="{ action: 'rename', item: asset }" (click)="_fileManagerComponent.renameItemDialog(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                                <span>Rename</span>
                                                            </button>
                                                        
                                                            <button mat-menu-item
                                                            (click)="drawerView(asset.id)"
                                                                [matMenuTriggerFor]="fmItemActionMenu_card_sub1">
                                                                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                                                                <span>Details</span>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu_card_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                                <button mat-menu-item
                                                                (click)="drawerView(asset.id, '0')">
                                                                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                                                                    <span>Info</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                 (click)="drawerView(asset.id, '1')">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:auto_graph"></mat-icon>
                                                                    <span>Activity</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                (click)="drawerView(asset.id, '2')">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:notes"></mat-icon>
                                                                    <span>Notes</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                (click)="drawerView(asset.id, '3')" *appIsDisplayed="'viewPermissions'">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:admin_panel_settings"></mat-icon>
                                                                <span>Permissions</span>
                                                             </button>
                                                            </mat-menu>
                                                            <button mat-menu-item
                                                                [matMenuTriggerFor]="fmItemActionMenu_sub1">
                                                                <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                                <span>Organize</span>
                                                            </button>  
                                                            <mat-menu #fmItemActionMenu_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                                <button mat-menu-item
                                                                    [appAction]="{ action: 'move', item: asset }"
                                                                    (click)="move(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                                    <span>Move</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                    (click)="toggleStar(asset)">
                                                                    <mat-icon 
                                                                        class="icon-size-4"
                                                                        [ngClass]="{'text-orange-500 dark:text-orange-400': asset.favourite}" 
                                                                        svgIcon="heroicons_outline:star">
                                                                    </mat-icon>
                                                                    <span>{{asset.favourite ? "Remove Star" : "Star"}}</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                    [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                                    <span>Labels</span>
                                                                </button>
                                                                <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                                        <button mat-menu-item
                                                                            (click)="toggleLabel(asset.id,label.id,checkbox)"
                                                                            matRipple>
                                                                            <mat-checkbox
                                                                                #checkbox
                                                                                class="pointer-events-none label-chip"
                                                                                [ngClass]="labelColors[label.color]?.combined"
                                                                                [color]="'primary'"
                                                                                [checked]="selectedLabel(label.id, asset.labels)"
                                                                                [disableRipple]="true">
                                                                                {{label?.name}}
                                                                            </mat-checkbox>
                                                                        </button>
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </mat-menu>
                                                            <div class="border-t"></div>
                                                            <button *appAction="{ action: 'delete', item: asset }"
                                                                mat-menu-item
                                                                (click)="trash(asset)">
                                                                <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                                <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                            </button>
                                                        </mat-menu>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            </div>
                                        </cdk-virtual-scroll-viewport>
                                    </ng-container>
                                    
                    
                                </div>
                                <!--Pagination-->
                                
                                <mat-paginator
                                    [ngClass]="{'pointer-events-none': isLoading}"
                                    [length]="total"
                                    [pageIndex]="page.page"
                                    [pageSize]="page.size"
                                    [pageSizeOptions]="pageLimitList"
                                    (page)="onPageChanged($event)"
                                    [showFirstLastButtons]="true"></mat-paginator>

                            </ng-container>
                    
                        </div>
                    </ng-container>
                    <!-- Grid view - END -->

                </ng-container>

                <!-- No items template -->
                <!--TODO - explore animation/transition; consider explicit linedashed drag and drop area-->
                <ng-template #noItems>
                    <div class="p-4 file-manager-viewport-empty">
                        <div  *ngIf="!isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <mat-icon
                          
                                class="icon-size-24"
                                [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                        </div>

                        <div  *ngIf="isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">Loading Data ... Please Wait</div>
                        </div>
                    </div>
                </ng-template>
            </div>
        <!--Scroll to top-->
        <button mat-mini-fab
            *ngIf="viewMode === 'grid' && showScrollToTopButton"
            matTooltip="Scroll to top"
            (click)="scrollToTop()"
            [color]="'primary'" 
            class="viewport-scroll-return-btn">
            <mat-icon [svgIcon]="'feather:chevron-up'"></mat-icon>
        </button>

    </mat-drawer-content>

</mat-drawer-container>

    <!-- a hidden div is created to set the position of appearance of the menu--> 
    <div 
    #fmActionMenuMainTrigger   
        style="visibility: hidden; position: fixed;" 
        [style.left.px]="menuTopLeftPosition.x" 
        [style.top.px]="menuTopLeftPosition.y" 
        [matMenuTriggerFor]="fmItemActionMenuItem"
        #fmItemActionMenuItemTrigger="matMenuTrigger">
    </div> 
    <!--TODO - split functions for context action menu for file & folders-->
    <mat-menu #fmItemActionMenuItem="matMenu" class="file-manager-item-action-menu">
        <ng-template matMenuContent let-item="item"> 
            <button class="menu-header">Item: {{item?.name}} {{item?.type}}</button> 
            <!--TODO catch type of record from the file-manager.types.ts Item object-->
            <!--TODO hide 'download' and other options that are for Files only-->
            <button *ngIf="item.type=='FILE'" mat-menu-item
                [appAction]="{ action: 'download', item: item }"
                (click)="download(item)">
                <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                <span>Download</span>
            </button>
            <button mat-menu-item
            [appAction]="{ action: 'share', item: item }"
            (click)="_fileManagerComponent.shared(item)">
               <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
               <span>Share</span>
           </button>
            <button mat-menu-item
                [appAction]="{ action: 'copy', item: item }"
                (click)="copyAsset(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:file_copy"></mat-icon>
                <span>Make a copy</span>
            </button>

            <div *ngIf="item.type=='FILE'" class="border-t"></div>
            <div class="flex w-full">
                <button *appAction="{ action: 'view', item: item }" mat-menu-item (click)="previewFile(item)">
                    <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
                    <span>View</span>
                </button>
                <button *appAction="{ action: 'edit', item: item }" mat-menu-item
                    (click)="editFile(item)">
                    <mat-icon class="icon-size-4" svgIcon="feather:edit"></mat-icon>
                    <span>Edit</span>
                </button>
            </div>

            <!-- Divider -->
            <div class="border-t"></div>

             <!-- Checkout -->
             <button (click)="checkoutAsset(item)" *appAction="{ action: 'lock', item: item }" mat-menu-item>
                <mat-icon class="icon-size-4" svgIcon="mat_outline:lock"></mat-icon>
                <span>Checkout</span>
            </button>

            <!-- Unlock request -->
            <button (click)="requestRelease(item)" *appAction="{ action: 'requestAccess', item: item }" mat-menu-item>
                <mat-icon class="icon-size-4" svgIcon="mat_outline:near_me"></mat-icon>
                <span>Request lock release</span>
            </button>

            <!-- Release  -->
            <button (click)="checkInAsset(item)" *appAction="{ action: 'unlock', item: item }" mat-menu-item>
                <mat-icon class="icon-size-4" svgIcon="mat_outline:lock_open"></mat-icon>
                <span>Unlock</span>
            </button>

            <button mat-menu-item  [appAction]="{ action: 'rename', item: item }"
                (click)="_fileManagerComponent.renameItemDialog(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                <span>Rename</span>
            </button>

            <button mat-menu-item
             (click)="drawerView(item.id)"
                [matMenuTriggerFor]="fmItemActionMenu_card_sub3">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                <span>Details</span>
            </button>
            <mat-menu #fmItemActionMenu_card_sub3="matMenu" class="file-manager-item-action-menu-sub">
                <button mat-menu-item
                (click)="drawerView(item.id, '0')">
                    <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
                    <span>Info</span>
                </button>
                <button mat-menu-item
                (click)="drawerView(item.id, '1')">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:auto_graph"></mat-icon>
                    <span>Activity</span>
                </button>
                <button mat-menu-item
                (click)="drawerView(item.id, '2')">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:notes"></mat-icon>
                    <span>Notes</span>
                </button>
                <button mat-menu-item
                (click)="drawerView(item.id, '3')" *appIsDisplayed="'viewPermissions'">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:admin_panel_settings"></mat-icon>
                    <span>Permissions</span>
                </button>
            </mat-menu>
            <button mat-menu-item
                [matMenuTriggerFor]="fmItemActionMenu_sub1">
                <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                <span>Organize</span>
            </button>  
            <mat-menu #fmItemActionMenu_sub1="matMenu" class="file-manager-item-action-menu-sub">
                <button mat-menu-item
                    [appAction]="{ action: 'move', item: item }"
                    (click)="move(item)">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                    <span>Move</span>
                </button>
                <button mat-menu-item
                    (click)="toggleStar(item)">
                    <mat-icon 
                        class="icon-size-4"
                        [ngClass]="{'text-orange-500 dark:text-orange-400': item.favourite}" 
                        svgIcon="heroicons_outline:star">
                    </mat-icon>
                    <span><span>{{item?.favourite? "Remove Star" : "Star"}}</span></span>
                </button>
                <button mat-menu-item
                    [matMenuTriggerFor]="fmItemActionMenu_sub_labels">
                    <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                    <span>Labels</span>
                </button>
                <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                        <button mat-menu-item
                            (click)="toggleLabel(item.id, label.id,checkbox)"
                            matRipple>
                            <mat-checkbox
                                #checkbox
                                class="pointer-events-none label-chip"
                                [ngClass]="labelColors[label.color].combined"
                                [color]="'primary'"
                                [checked]="selectedLabel(label.id, item.labels)"
                                [disableRipple]="true">
                                {{label?.name}}
                            </mat-checkbox>
                        </button>
                    </ng-container>
                </mat-menu>
            </mat-menu>
            <!-- Divider -->
            <div class="border-t"></div>
            <button *appAction="{ action: 'delete', item: item }"
                 mat-menu-item
                (click)="trash(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
            </button>
        </ng-template>
    </mat-menu>
    
</div>

